import { Injectable } from '@angular/core';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, map, Subject, takeUntil } from 'rxjs';

import { subjectFromObs } from 'core/rx-js';
import { IPageInfo, PdfViewerService } from '../../pdf-viewer.service';
import { IPdfDocument } from '../../types';
import { PdfDocumentViewportService } from '../pdf-document-viewport/pdf-document-viewport.service';

@Injectable()
export class PdfPageService {

  readonly PNG_BASE64_PREFIX = 'data:image/png;base64, ';
  private readonly _destroy = new Subject<void>();

  readonly pageInfoSubject = new BehaviorSubject<IPageInfo>(undefined)
  readonly renderedSubject = new BehaviorSubject<boolean>(false);

  readonly selectedZoomSubject = this._pdfViewportService.selectedZoomSubject;

  readonly canvasElementSubject = new BehaviorSubject<HTMLCanvasElement>(undefined)
  readonly divOverlaySubject = new BehaviorSubject<HTMLDivElement>(undefined)
  readonly pageIdxSubject = new BehaviorSubject<number>(undefined)
  readonly pdfDocumentSubject = new BehaviorSubject<IPdfDocument>(undefined)
  readonly renderingSubject = new BehaviorSubject<boolean>(false)
  readonly alreadyRenderedSubject = new BehaviorSubject<boolean>(false);

  readonly renderedRangeObs = this._pdfViewportService.renderedRangeObs;
  //quick fix
  readonly renderingQueue: (() => Promise<any>)[] = []


  readonly scrollTopSubject = this._pdfViewerService.scrollTopSubject;

  readonly pdfPageVisibleSubject = subjectFromObs({
    observable: combineLatest([
      this.pageInfoSubject,
      this._pdfViewerService.pageIdxSubject,
    ])
      .pipe(
        filter(([pageInfo]) => Boolean(pageInfo)),
        map(([pageInfo, pageIdx]) => Math.abs(pageInfo.pageIdx - pageIdx) < 4),
        distinctUntilChanged()
      ),
    initialValue: false
  })
  readonly pageBase64pngsSubject = this._pdfViewerService.pageBase64pngsSubject;

  readonly imgPathObs = combineLatest([this.pageInfoSubject, this.pageBase64pngsSubject]).pipe(
    map(([pageInfo, pageBase64pngs]) => pageBase64pngs[pageInfo.pageIdx]),
    map(base64 => base64 ? this.PNG_BASE64_PREFIX + base64 : undefined),
    distinctUntilChanged()
  )

  constructor(
    private _pdfViewportService: PdfDocumentViewportService,
    private _pdfViewerService: PdfViewerService
  ) {


    this.canvasElementSubject
      .pipe(
        filter((canvas) => !canvas),
        takeUntil(this._destroy)
      )
      .subscribe(() => {
        this.renderedSubject.next(false)
      })

  }



  // async renderPage(pageInfo: IPageInfo) {


  //   const scale = 1;
  //   const rendered = this.renderedSubject.value
  //   const canvasElement = this.canvasElementSubject?.value;
  //   if (!scale || !pdfPageProxy || !canvasElement || rendered) {
  //     return
  //   }


  //   const viewPort = pdfPageProxy.getViewport({ scale });
  //   const ctx = canvasElement.getContext('2d');

  //   if (!ctx) {
  //     return;
  //   }

  //   this.viewport = viewPort.clone();

  //   try {
  //     this.renderingSubject.next(true);
  //     pdfPageProxy.render({
  //       canvasContext: ctx,
  //       viewport: this.viewport,

  //     }).promise
  //       .then(() => {

  //         setTimeout(() => {
  //           this.renderedSubject.next(true);
  //           this.renderingSubject.next(false);
  //         }, 250)

  //       })
  //       .catch((err) => {
  //         throw err
  //       })
  //   }
  //   catch (err) {
  //     console.error(err)
  //   }
  //   return
  // }


  ngOnDestroy() {
    this._destroy.next();
    this._destroy.complete();
  }


}
